import createStoreWithContext from '@/utils/store/create-store-with-context'

import BlogApis from '../../apis'

const { withStore, useStore: useBlogPost } = createStoreWithContext(
  (set, get, swrFields) => ({
    ...swrFields,
  }),
  (data, query) => ({
    key: `blog-post-${query}`,
    initialData: data,
    fetcher: () => BlogApis.getPost(query?.handle),
    storeKey: 'post',
  }),
)

export const withBlogPostStore = withStore

export default useBlogPost
